import { differenceInSeconds } from 'date-fns'

export interface IGeoLocation {
  lat: number
  lng: number
}

export interface IVehicle {
  id:                 string
  arrivesAt:          Date
  shouldShow:         boolean
  driverName:         string
  arrivalDuration:    number
  geolocation?:       IGeoLocation
  vendorGeolocation:  IGeoLocation
}

export interface IVehicleFactory extends IVehicle {}

export class Vehicle {
  id:                 string
  arrivesAt:          Date
  shouldShow:         boolean
  arrivalDuration:    number
  driverName:         string
  geolocation?:       IGeoLocation
  vendorGeolocation:  IGeoLocation

  constructor(vehicleData: IVehicle) {
    this.id                 = vehicleData.id
    this.arrivesAt          = vehicleData.arrivesAt
    this.shouldShow         = vehicleData.shouldShow
    this.arrivalDuration    = vehicleData.arrivalDuration
    this.driverName         = vehicleData.driverName
    this.geolocation        = vehicleData.geolocation
    this.vendorGeolocation  = vehicleData.vendorGeolocation
  }

  get arrivesIn(): number {
    return differenceInSeconds(this.arrivesAt, new Date())
  }

  progress(): number {
    return this.arrivesIn / this.arrivalDuration * 100
  }
}

export const createVehicle = (vehicleData: IVehicleFactory): Vehicle => {
  return new Vehicle(vehicleData)
}
